export const tabNames = () => [
  {
    tabName: 'Overview',
  },
  {
    tabName: 'Settings',
  },
  {
    tabName: 'Activity',
  },
];

export const filteredTabNames = (isLink: boolean) => {
  return tabNames().filter((tab) => !isLink || tab.tabName !== 'Settings');
};
